




















import Vue from 'vue'
export default Vue.extend({
  components: {  },
  data() {
    return {
      fields: {
        text: {
          value: "",
          type: "search",
          tag: "input",
        }
      }
    }
  }
})
